import { jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Button({ variant = "secondary", compact, loading, leftIcon, className, type = "button", children, ...rest }) {
    return (_jsxs("button", { type: type, className: cn("fwfa-button", `fwfa-button--${variant}`, compact && "fwfa-button--compact", loading && "is-loading", className), "aria-busy": loading || undefined, ...rest, children: [!loading && leftIcon, children] }));
}
//# sourceMappingURL=Button.js.map